import { of } from "rxjs";
import { htmlUrls } from "@shared/utils/router-paths";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { MatDialog } from "@angular/material/dialog";
import { BaseComponent } from "@shared/components/base/base.component";
import { FileService } from "@shared/service/http_services/file.service";
import { SearchService } from "@shared/service/http_services/search.service";
import { TermFilterModel } from "@shared/model/categoryAndSearch/term-filter-model";
import { switchMap, take, takeUntil, tap } from "rxjs/operators";
import { AggregateSearchResultModel } from "@shared/model/aggreegate-search-result-model";
import { Component, OnInit, inject } from "@angular/core";
import { ActivitiesUpdateService } from "@shared/service/http_services/activitiesUpdate.service";
import { NavigationEnd, Router, RouterOutlet, Event, RouterLink, EventType, RouterLinkActive } from "@angular/router";
import { SelectedMergeListComponent } from "@app/pages/merge/components/selected-merge-list/selected-merge-list.component";
import { InvokeSignalService } from "@shared/service/signal_services/invoke-signal.service";
import { FloatingActionsComponent } from "@shared/components/floating-actions/floating-actions.component";
import { MergeService } from "./merge/service/merge.service";
import { IFollowStateData } from '@shared/components/follow-btn/pipe/follow-user-data.pipe';
import { FollowItemService } from '@shared/service/follow-item.service';
import { EImageType, ImagePipe } from '@shared/pipes/image.pipe';
import { SignalHubService } from '@shared/service/signal_services/signal-hub.service';
import { ExitBottomSheetComponent } from '@shared/components/bottom-sheets/exit-bottom-sheet/exit-bottom-sheet.component';
import { BehkhaanSuggestionSetAvatarComponent, closeSuggestionEnum } from '@shared/components/behkhaan-suggestion-set-avatar/behkhaan-suggestion-set-avatar.component';
import { ESlidenavMenu, ISidenavMenu } from './feeds/components/sidenav-menu-item/models';
import { SidenavMenuGenerator } from './feeds/helper';
import { ESidenavMenuType } from './feeds/helper/sidenav-menu-type.enum';
import { SharedModule } from '@shared/module/shared.module';
import { SidenavMenuItemComponent } from './feeds/components/sidenav-menu-item/sidenav-menu-item.component';
import { HomeCurrentlyReadingComponent } from '@shared/components/home-currently-reading/home-currently-reading.component';
import { LoadingComponent } from "@shared/components/loading/loading.component";
import { AuthContainerDialogComponent } from "@app/auth/auth-container-dialog/auth-container-dialog.component";
import { FeedsFacadeService } from "./feeds/feeds-facade.service";
import { NotificationFacadeService } from "./notifications/services/notification-facade.service";
import { ViewTrackerService } from "@shared/service/view-service/view-tracker.service";
import { routeTransition } from "@app/route-transitions";
import { ExploreFacadeService } from "./explore/service/explore-facade.service";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatMenuModule, MatMenuTrigger } from "@angular/material/menu";
import { ESearchTab } from "./search/models/search-tab.enum";
import { LayoutSearch } from "@shared/components/layout-search/layout-search";
import { ACCESS_TOKEN_KEY } from "constants/storage-keys";

const DisplaySetAvatar = 'displaySetAvatar';
declare let Goftino: any;

@Component({
  selector: "layout",
  templateUrl: "./layout.html",
  styleUrls: ["./layout.scss"],
  animations: [
    routeTransition
  ],
  imports: [
    SharedModule,
    RouterLink,
    RouterLinkActive,
    SidenavMenuItemComponent,
    FloatingActionsComponent,
    RouterOutlet,
    BehkhaanSuggestionSetAvatarComponent,
    HomeCurrentlyReadingComponent,
    LoadingComponent,
    MatMenuModule,
    MatButtonModule,
    MatButtonToggleModule,
    ImagePipe,
    LayoutSearch
  ]
})
export class LayoutComponent extends BaseComponent implements OnInit {
  router = inject(Router);
  dialog = inject(MatDialog);
  fileService = inject(FileService);
  searchService = inject(SearchService);
  _bottomSheet = inject(MatBottomSheet);
  signalHubService = inject(SignalHubService);
  invokeSignalService = inject(InvokeSignalService);
  activitiesUpdateService = inject(ActivitiesUpdateService);
  mergeService = inject(MergeService);
  followItemService = inject(FollowItemService);
  _sidenavMenuGenerator = inject(SidenavMenuGenerator);
  feedsFacadeService = inject(FeedsFacadeService);
  notificationFacadeService = inject(NotificationFacadeService);
  notifFacadeService = inject(NotificationFacadeService);
  viewTrackerService = inject(ViewTrackerService);
  exploreFacadeService = inject(ExploreFacadeService);

  displaySetAvatar = false;
  profileImage: string | null = null;
  routes = htmlUrls;
  notificationCount = 0;
  suggesstionTermFilter: TermFilterModel = new TermFilterModel();
  loadingResult!: boolean;
  mergePublisherCount$ = this.mergeService.selectedPublisherToMerge;
  mergeAuthCount$ = this.mergeService.selectedAuthorToMerge;
  mergeBookCount$ = this.mergeService.selectedBookToMerge;
  displayActions = false;
  imageType = EImageType;
  sidenavItems: ISidenavMenu[] = [];
  messagingLoading = false;
  eSlidenavMenu = ESlidenavMenu;
  currentUrl = '';
  prevUrl = '';
  result: AggregateSearchResultModel | null = null;


  constructor() { super() }

  ngOnInit() {
    this.userDataChangeHandler().subscribe();
    if (this.Repository.IsInBrowser) {
      this.handleSignalRConnection().subscribe();
      this.handleNotifCount().subscribe();
      this.routerEventListener().subscribe();
      this.newNotificationListener().subscribe();
      this.avatarChangeHandler().subscribe();
      if (this.currentUser) {
        this.getUnSeenNotificationsCount().subscribe();
      }
    }
  }

  handleSignalRConnection() {
    return this.signalHubService.connectedSubscribtion.pipe(
      takeUntil(this.unsubscribe$),
      tap(c => c ? this.signalHubService.startConnection() : null)
    );
  }

  handleNotifCount() {
    return this.appStateService.notificationCountModifier$.pipe(
      takeUntil(this.unsubscribe$),
      tap(c => this.notificationCount = c || 0)
    );
  }


  sendQueuedViews(event: Event) {
    if (event instanceof NavigationEnd) {
      this.prevUrl = this.currentUrl;
      this.currentUrl = event.url;
      const isLeavingProfile = this.prevUrl?.includes('profile');
      if (isLeavingProfile) {
        return this.viewTrackerService.submitQueuedViews();
      }
    }
    return of(null);
  }

  modifyMessagingLoading(event: Event) {
    if (event.type === EventType.ResolveEnd && event.url.includes('messages')) {
      this.messagingLoading = false;
    }
    else if (event.type === EventType.NavigationStart && event.url.includes('messages')) {
      this.messagingLoading = true;
    }
  }

  routerEventListener() {
    return this.router.events.pipe(
      takeUntil(this.unsubscribe$),
      switchMap(event => {
        this.modifyMessagingLoading(event);
        return this.Repository.getCookieItem(ACCESS_TOKEN_KEY) ? this.sendQueuedViews(event) : of(null);
      })
    );
  }

  // ? Signal R check for new notifications
  newNotificationListener() {
    return this.invokeSignalService.newNotification$.pipe(
      takeUntil(this.unsubscribe$),
      tap((res) => {
        if (res) {
          if (res?.data?.payLoad?.type == "Notif") {
            this.notificationCount++;
            this.appStateService.hasNewNotification$ = true;
          }
        }
      })
    );
  }


  // TODO remove facades here and handle with subjects
  userDataChangeHandler() {
    return this.userStateService.userData.pipe(
      takeUntil(this.unsubscribe$),
      tap(d => {
        if (!d?.id) {
          this.clearClientSideCache();
        }
        this.displaySetAvatar = !d?.hasPhoto!;
        this.generateMenuItems();
      })
    );
  }

  avatarChangeHandler() {
    return this.fileService.userImageOBS_$.pipe(
      takeUntil(this.unsubscribe$),
      tap((res) => {
        if (res) {
          this.profileImage = res;
          this.displaySetAvatar = false;
        } else {
          if (this.currentUser?.id) {
            this.profileImage = '';
            this.displaySetAvatar = true;
            this.currentUser.hasPhoto = false;
          }
        }
      })
    );
  }


  search(term: string) {
    if (term && term.length > 1) {
      this.loadingResult = true;
      this.suggesstionTermFilter.searchTerm = this.utilFunctions.replaceFaNumbers(term);
      this.searchService.searchSuggesstion(this.suggesstionTermFilter).pipe(take(1)).subscribe(res => {
        this.loadingResult = false;
        if (res && !res.hasError) {
          this.result = res.result;
        }
        else
          this.clearResults();
      })
    }
    else {
      this.loadingResult = false;
      this.clearResults();
    }
  }

  clearClientSideCache() {
    this.feedsFacadeService.clearFeedCache();
    this.notifFacadeService.clearNotificationCache();
  }


  generateMenuItems() {
    this.sidenavItems = this._sidenavMenuGenerator.generate(ESidenavMenuType.LAYOUT);
  }

  removeSetAvatarCard(event: closeSuggestionEnum) {
    if (event === closeSuggestionEnum.userClosed) {
      this.Repository.setLocalItem(DisplaySetAvatar, "F");
    }
    this.displaySetAvatar = false;
  }

  getUnSeenNotificationsCount() {
    return this.activitiesUpdateService.getUnSeenNotificationsCount().pipe(
      switchMap((res) => {
        if (!res.hasError && res.result) {
          this.notificationCount = res.result;
        }
        return this.appStateService.notificationCountModifier$;
      }),
      tap(res => {
        this.notificationCount = res || 0;
      }),
      takeUntil(this.unsubscribe$)
    );
  }

  openSignin() {
    if (this.Repository.IsInBrowser) {
      this.dialog.open(AuthContainerDialogComponent, {
        panelClass: 'auth-dialog',
        data: {
          redirectPath: null
        },
        disableClose: true
      });
    }
  }

  logout() {
    if (!this.Repository.IsInBrowser) return;
    if (this.Repository.IsInMobile) {
      this._bottomSheet.open(ExitBottomSheetComponent, {
        panelClass: "exit-bottom-sheet",
      });
      return;
    }
    this.dialog.open(ExitBottomSheetComponent, {
      panelClass: "basic-dialog",
    });
  }

  openMergeDialog() {
    this.dialog.open(SelectedMergeListComponent, {
      panelClass: "merge-dialog",
      width: '400px',
      height: 'auto'
    });
  }

  navigateToSearchPage(event: { cat: ESearchTab, term: string }) {
    if (this.Repository.IsInBrowser) {
      this.router.navigate([htmlUrls.search], {
        queryParamsHandling: "merge",
        queryParams: {
          q: event.term,
          category: event.cat,
        },
      });
    }
  }

  clearResults() {
    this.result = null;
  }


  FollowClicked(item: IFollowStateData) {
    this.followItemService.Follow(item);
  }

  prepareRoute(outlet: RouterOutlet | null) {
    if (!outlet || !outlet.isActivated) {
      return of(null);
    }
    return outlet?.activatedRoute.url;
  }


  // ! review needed
  onAnimationDone() {
    this.feedsFacadeService.runSetTimeout();
    this.exploreFacadeService.runSetTimeout();
    this.notificationFacadeService.runSetTimeout();
  }


  actionButtonsMobile() {
    this.displayActions = !this.displayActions;
    const actionDialog = this.dialog.open(FloatingActionsComponent, {
      panelClass: "floatin-mobile",
      width: "100%",
      data: {
        displayActions: this.displayActions,
      },
    });

    actionDialog.afterClosed().pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
      this.displayActions = false;
      if (res?.type === "displayReadingBooks") {
        // ? Redirect to currently reading page just for mobile
        this.router.navigate([this.routes.challenges_progress]);
      }
    });
  }

  onSidenavItemClicked(item: ISidenavMenu, menuTrigger?: MatMenuTrigger) {
    if (item.type === ESlidenavMenu.SUPPORT) {
      Goftino.open();
    }
    else if (item.type === ESlidenavMenu.More) {
      menuTrigger?.openMenu();
    }
  }

  closeSubmenu(item: ISidenavMenu) {
    item.expanded = false;
  }

}
